<template>
  <div id="select-currency-form">
    <form class="tw-w-full tw-mt-8" @submit.prevent="storeData('fiat')">
      <SelectInput
        label="Currency"
        defaltOption="Select currency"
        name="currency"
        id="currency"
        :list="currencyList"
        @set="setCurrencyData"
      />
      <!-- <div
        v-if="
          (currency === 'USD' && fundOptions !== 'Fund with Fluidcoins') ||
          (currency === 'EUR' && fundOptions !== 'Fund with Fluidcoins') ||
          (currency === 'GBP' && fundOptions !== 'Fund with Fluidcoins') ||
          (currency === 'NGN' && fundOptions !== 'Fund with Fluidcoins')
        "
        class="tw-mt-14"
      >
        <label
          v-if="!loading"
          class="tw-flex tw-items-center tw-border tw-rounded tw-cursor-pointer tw-px-4 tw-py-4 tw-mb-4"
          for="fiat"
          @click="storeData('fiat')"
        >
          <h3>Fund with debit/credit card</h3>
        </label>
        <div
          v-if="!loading && !virtualAccount?.currency"
          class="tw-flex tw-items-center tw-border tw-rounded tw-cursor-pointer tw-px-4 tw-py-4"
          for="virtual"
          @click="storeData('virtual')"
        >
          <h3>Generate dedicated virtual account</h3>
        </div>
        <div
          v-if="!loading && virtualAccount?.currency"
          class="tw-border tw-rounded tw-px-4 tw-py-4 tw-cursor-pointer"
          @click="gotoVirtualAccountForm"
        >
          <h3>Fund with dedicated virtual account</h3>
          <p class="status tw-bg-lemon tw-py-1 tw-px-2 tw-mt-2">Created</p>
        </div>
      </div> -->
      <!-- <SmallLoader
        v-if="
          loading &&
          (fundMethod === 'virtual' ||
            fundMethod === 'fiat' ||
            fundMethod === 'crypto')
        "
      /> -->
      <!-- <SmallLoader v-if="loading && fundMethod === 'fiat'" /> -->
      <Btn class="tw-mt-8" :loading="loading" title="Continue" />
    </form>
  </div>
</template>

<script>
  import Btn from "@/components/general/BtnComponent.vue";
import SelectInput from "@/components/general/SelectInput.vue";
import { capitalize } from "@/utils/helpers";
import { getItem } from "@/utils/storage.js";
import { mapActions, mapState } from "vuex";

  export default {
    name: "SelectCurrencyForm",

    emits: ["storeData"],

    components: { SelectInput, Btn },

    props: {
      fundOptions: { type: String, default: () => "" },
    },

    data() {
      return {
        currency: "",
        fundMethod: "fiat",
        userDetails: {},
        currencyList: [],
        fiatCurrencyList: [
          "Nigerian Naira (NGN)",
          "Kenyan Shillings (KES)",
          // "Ghana",
          // "South Africa",
          // "European Countries",
          "United States Dollars (USD)",
          "Add Manually",
        ],
        fintechCurrencyList: ["🇳🇬 Nigerian Naira (NGN)"],
        cryptoCurrencyList: ["🇺🇸 US Dollars (USD)"],
      };
    },

    computed: {
      ...mapState({
        virtualAccount: (state) => state.organisationModule.virtualAccount,
        loading: (state) => state.smallLoading,
      }),
    },

    mounted() {
      this.userDetails = getItem("org_details");
      this.setCurrencyList();
    },

    methods: {
      ...mapActions("organisationModule", [
        "setCurrency",
        "setFundMethod",
        "getExchangeRate",
        "getVirtualAccount",
      ]),

      capitalize,

      async storeData(method = "fiat") {
        this.fundMethod = method;
        this.setCurrency(this.currency);
        this.setFundMethod(this.fundMethod);
        // if (this.fundMethod !== "fiat") return;
        const exchangeQuery = { from: "USD", to: this.currency };
        const response = await this.getExchangeRate(exchangeQuery);
        if (response) this.$emit("storeData", "selectCurrencyForm");
      },

      gotoVirtualAccountForm() {
        this.setCurrency(this.currency);
        this.$emit("storeData", "DedicatedVirtualAccountForm");
      },

      setCurrencyData(currency) {
        if (!currency) return;
        let abb = currency.split("(")[1].split(")")[0];
        this.currency = abb;
        if (this.fundOptions === "Fund with Fluidcoins") {
          this.storeData("crypto");
          return;
        }
      },

      setCurrencyList() {
        this.currencyList = this.fiatCurrencyList;
        // switch (this.fundOptions) {
        //   case "Fund with Cash":
        //     this.currencyList = this.fiatCurrencyList;

        //     break;
        //   case "Fund with Fluidcoins":
        //     this.currencyList = this.cryptoCurrencyList;

        //     break;
        //   case "Fund with Fintech Apps":
        //     this.currencyList = this.fintechCurrencyList;

        //     break;

        //   default:
        //     this.currencyList = this.fiatCurrencyList;
        //     break;
        // }
      },
    },

    watch: {
      virtualAccount(newValue, oldValue) {
        deep: true;
        immediate: true;
        if (newValue !== oldValue) {
          this.fundMethod = "fiat";
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  #select-currency-form {
    .status {
      width: 5rem;
    }
  }
</style>
